import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyFeService } from './companyfe.service';

@Injectable({
    providedIn: 'root'
})
export class DeepLinkService {
    private readonly _router = inject(Router);
    private readonly _companyFeService = inject(CompanyFeService);

    private _pendingUrl: string | null = null;
    private _isProcessing = false;

    storePendingUrl(url: string): void {
        if (url === '/' || url === '/home' || url.startsWith('/auth')) {
            return;
        }

        this._pendingUrl = url;
    }

    setCompany(): void {
        if (!this._pendingUrl || this._isProcessing) {
            return;
        }

        this._isProcessing = true;

        try {
            // const urlTree = this._router.parseUrl(this._pendingUrl);
            // const companyIdParam = urlTree.queryParams['company'];
            
            // if (companyIdParam) {
            //     const companyId = Number(companyIdParam);

            //     if (Number.isNaN(companyId)) {
            //         this._companyFeService.onSelectedCompany(companys[0]);
            //     }
            //     else {
            //         const company = companys.find(c => c.id === companyId);
            //         this._companyFeService.onSelectedCompany(company ?? companys[0]);
            //     }
            // } else {
            //     this._companyFeService.onSelectedCompany(companys[0]);
            // }

            this._companyFeService.onSelectedCompany();

            const url = this._pendingUrl;
            this._pendingUrl = null;
            this._router.navigateByUrl(url);

        } catch (error) {
            console.error('Error processing deep link:', error);
            this._pendingUrl = null;
        } finally {
            this._isProcessing = false;
        }
    }

    hasPendingUrl(): boolean {
        return !!this._pendingUrl;
    }
}
